// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__vy7Tn","label":"LabeledBox_label__1ZE8I"};